import MapView from '../components/MapView'

function MapLayers() {
  return (
    <div className="map-container">
      <MapView />
    </div>
  )
}

export default MapLayers
